import Login from "@view/login"
import Error404 from "@view/error/404"
import Layout from "@view/layout"

const staticRoutes = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  // 未找到页面
  {
    path: '/404',
    name: '404',
    component: Error404,
  },
];

const defaultRoutes = [
  // 斜杠跳转登录页面
  {
    path: '/',
    redirect: '/index',
    hidden: true
  },
  // 没有页面跳转错误页面
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
];

const mac = {
  path: '/mac',
  component: Layout,
  meta: {
    subMenu: true,
    title: "MAC管理",
    icon: "el-icon-cpu",
  },
  children: [
    {
      path: "/mac/order",
      name: "macOrder",
      component: () => import("@sub-view/mac/order"),
      meta: {
        title: "MAC订单",
        permission: ["macOrder"],
      }
    },
    {
      path: "/mac/pool",
      name: "macPool",
      component: () => import("@sub-view/mac/pool"),
      meta: {
        title: "MAC池",
        permission: ["macPool"],
      }
    },
  ]
};

const oem = {
  path: '/oem',
  component: Layout,
  meta: {
    subMenu: true,
    title: "厂商管理",
    icon: "el-icon-menu",
  },
  children: [
    {
      path: "/oem/mac",
      name: "oemMac",
      component: () => import("@sub-view/oem/mac"),
      meta: {
        title: "厂商MAC",
        permission: ["oemMac"],
      }
    },
    {
      path: "/oem/model",
      name: "oemModel",
      component: () => import("@sub-view/oem/model"),
      meta: {
        title: "厂商型号",
        permission: ["oemModel"],
      }
    },
    {
      path: "/oem/company",
      name: "oemCompany",
      component: () => import("@sub-view/oem/company"),
      meta: {
        title: "厂商列表",
        permission: ["oemCompany"],
      }
    },
  ]
};

const deviceAuth = {
  path: '/device-auth',
  component: Layout,
  meta: {
    subMenu: true,
    title: "设备授权",
    icon: "el-icon-monitor",
  },
  children: [
    {
      path: "/device-auth/model",
      name: "deviceAuthModel",
      component: () => import("@sub-view/deviceAuth/model"),
      meta: {
        title: "自定义型号",
        permission: ["deviceAuthModel"],
      }
    },
    {
      path: "/device-auth/test",
      name: "deviceAuthTest",
      component: () => import("@sub-view/deviceAuth/test"),
      meta: {
        title: "测试授权",
        permission: ["deviceAuthTest"],
      }
    },
    {
      path: "/device-auth/formal",
      name: "deviceAuthFormal",
      component: () => import("@sub-view/deviceAuth/formal"),
      meta: {
        title: "正式授权",
        permission: ["deviceAuthFormal"],
      }
    },
    {
      path: "/device-auth/list",
      name: "deviceAuthList",
      component: () => import("@sub-view/deviceAuth/list"),
      meta: {
        title: "设备列表",
        permission: ["deviceAuthList"],
      }
    },
    {
      path: "/device-auth/log",
      name: "deviceAuthLog",
      component: () => import("@sub-view/deviceAuth/log"),
      meta: {
        title: "授权日志",
        permission: ["deviceAuthLog"],
      }
    },
  ]
};

const platformAuth = {
  path: '/platform-auth',
  component: Layout,
  meta: {
    subMenu: true,
    title: "平台授权",
    icon: "el-icon-cloudy",
  },
  children: [
    {
      path: "/platform-auth/server",
      name: "platformAuthServer",
      component: () => import("@sub-view/platformAuth/server"),
      meta: {
        title: "授权服务",
        permission: ["platformAuthServer"],
      },
    },
    {
      path: "/platform-auth/price",
      name: "platformAuthPrice",
      component: () => import("@sub-view/platformAuth/price"),
      meta: {
        title: "授权价格",
        permission: ["platformAuthPrice"],
      }
    },
    {
      path: "/platform-auth/order",
      name: "platformAuthOrder",
      component: () => import("@sub-view/platformAuth/order"),
      meta: {
        title: "授权订单",
        permission: ["platformAuthOrder"],
      }
    }
  ]
};

const app = {
  path: '/app',
  component: Layout,
  meta: {
    subMenu: false,
  },
  children: [
    {
      path: "/app/list",
      name: "appList",
      component: () => import("@sub-view/app/list"),
      meta: {
        icon: "el-icon-s-custom",
        title: "应用账号",
        permission: ["appList"],
      }
    }
  ]
};

const log = {
  path: '/log',
  component: Layout,
  redirect: "/log/export",
  meta: {
    subMenu: true,
    title: "日志管理",
    icon: "el-icon-s-order",
  },
  children: [
    {
      path: "/log/action",
      name: "logAction",
      component: () => import("@sub-view/log/action"),
      meta: {
        title: "操作日志",
        permission: ["logAction"],
      }
    },
    {
      path: "/log/login",
      name: "logLogin",
      component: () => import("@sub-view/log/login"),
      meta: {
        title: "登录日志",
        permission: ["logLogin"],
      }
    },
  ]
};

const permission = {
  path: '/permission',
  component: Layout,
  meta: {
    subMenu: true,
    title: "权限管理",
    icon: "el-icon-s-check",
  },
  children: [
    {
      path: "/permission/admin",
      name: "permissionAdmin",
      component: () => import("@sub-view/permission/admin"),
      meta: {
        title: "管理员列表",
        permission: ["permissionAdmin"],
      }
    },
    {
      path: "/permission/role",
      name: "permissionRole",
      component: () => import("@sub-view/permission/role"),
      meta: {
        title: "角色列表",
        permission: ["permissionRole"],
      }
    }
  ]
};

const dynamicRoutes = [
  mac,
  oem,
  deviceAuth,
  platformAuth,
  app,
  log,
  permission,
];

const initPermission = (routes, permission) => {
  routes.forEach(route => {
    if (route.children) {
      route.meta.permission = [];
      initPermission(route.children, route.meta.permission);
    }
    permission && route.meta.permission.forEach(item => permission.push(item));
  })
}

initPermission(dynamicRoutes);

export {staticRoutes, defaultRoutes, dynamicRoutes};
